<template>
    <div>
        <div class="d-flex flex-row" style="height: 100%;">
            <div class="col">
                <div class="content d-flex flex-column flex-column-fluid" style="margin: 4.4em 6em 2em 6em;">
                    <div v-if="mandatoryStepsCompleted" class="alert alert-success align-items-center card d-flex justify-content-between mb-12 py-6 gap-2">
                        <h6>{{ __('account-setup.setup_complete') }}</h6>
                        <a :href="$route('dashboard')" class="btn btn-primary">{{ __('actions.start_now') }}<i class="fas fa-arrow-circle-right ml-3"></i></a>
                    </div>
                    <account-setup-card
                        :key="step.id"
                        v-for="step in steps"
                        :route="step.route"
                        class="mb-10"
                        :icon="step.icon"
                        :title="step.title"
                        :current-step="step.id"
                        :sub-steps="step.subSteps"
                        :edit-button-text="step.finished ? __('actions.edit') : __('actions.start_now')"
                        :edit-button-class="step.finished ? 'btn-success' : 'btn-primary'"
                        :disabled="step.disabled">
                    </account-setup-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccountSetupCard from '@components/AccountSetup/AccountSetupCard';
import AccountSetupLayout from '@layouts/AccountSetupLayout';

export default {
    components: {
        AccountSetupCard,
    },
    layout: AccountSetupLayout,

    props: {
        steps: Object,
        company: Object,
        mainStepProgress: Object,
    },

    computed: {
        mandatoryStepsCompleted() {
            return this.mainStepProgress.company === true && this.mainStepProgress.subscription === true;
        },
    },
};
</script>
